import validators from '../../utils/validators';
import DrugStore from './store';

class DrugStock {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      link: (v) => validators.isStringOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid DrugStock property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }

    try {
      this.store = new DrugStore(data.store);
    } catch (e) {
      throw new Error(`Error in DrugStock in ${data.id}: ${e.message}`);
    }
  }
}

export default DrugStock;
